import { Component, Input, ElementRef, ViewChild, AfterViewChecked} from '@angular/core';
import { CommandsService } from '../services/commands.service';

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    providers: [CommandsService]
})

export class HistoryComponent implements AfterViewChecked {

    @ViewChild('scrollMe') private myScrollContainer: ElementRef;
    @Input('commandsServiceMaster') commandsService: CommandsService;

    //previous commands, used for scrolling through when using arrowUp and arrowDown
    private cmds: Object[];

    // Used to determine wether we want to scroll down in history or not
    private oldScrollHeight;

    // Direct reference to native element of container
    private history;

    constructor() {

    }

    ngOnInit() {
        this.history = this.myScrollContainer.nativeElement;

        //setup connection to commandsService, which provides this component with data (previous commands)
        this.commandsService.space.subscribe((value) => {
            this.cmds = this.commandsService.getData();
        });
    }

    //start automatic scrollDown. Used when new input added or arrowUp/arrowDown used
    scrollToBottom(): void {
        try {
            this.history.scrollTop = this.history.scrollHeight;
        } catch (err) {
            console.log("ERROR while scrolling to bottom. Check history component");
        }
    }

    /*
        The history will automatically scroll down with incomding commands.
        Only if the user has manually scrolled up is auto scrolling disabled.
        Once the user has scrolled to the bottom again, it will again auto-scroll.
    */
    shouldScroll(): boolean {
        return this.history.scrollTop + this.history.clientHeight === this.oldScrollHeight;
    }

    //when rerendering scroll down if at bottom of history
    ngAfterViewChecked() {
        if (this.shouldScroll()) {
            this.scrollToBottom();
        }

        this.oldScrollHeight = this.history.scrollHeight;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/history.component.ts